import { render, staticRenderFns } from "./PropertyTransactionForm.vue?vue&type=template&id=7859d783"
import script from "./PropertyTransactionForm.vue?vue&type=script&lang=js"
export * from "./PropertyTransactionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports